import React from 'react';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { customerSees } from '../../data/content';
export function Problem() {
  return <section className="bg-steel-100 py-12 sm:py-16" aria-labelledby="problem-title" data-id="element-259" data-mp="2roeyzzn0baqv">
      <div className="mx-auto w-full max-w-3xl px-4 sm:px-6" data-id="element-260" data-mp="2rmao2xqoxbh3">
        <h2 id="problem-title" className="text-center font-display text-[1.75rem] font-extrabold uppercase leading-[1.02] text-ink-900 sm:text-4xl" data-id="element-261" data-mp="2moitfvynvb97">
          Stop looking like a handyman.{' '}
          <span className="text-gold-600" data-id="element-262" data-mp="2cptas0yxxmrw">
            Start looking like a professional service business.
          </span>
        </h2>

        <div className="mt-6 space-y-3 text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-263" data-mp="23qprowzrx7de">
          <p data-id="element-264" data-mp="6xwaodvymlcc">Most appliance repair technicians are excellent at fixing appliances.</p>
          <p className="font-semibold text-ink-900" data-id="element-265" data-mp="6vtmlzedb2a9">
            But their customers don’t see what’s happening behind the scenes.
          </p>
        </div>

        <div className="mt-6 rounded-2xl border border-ink-900/10 bg-white p-4 sm:p-6" data-id="element-266" data-mp="14aahs3bb4cdm">
          <p className="flex items-center gap-2 font-display text-lg font-bold uppercase tracking-wide text-ink-900" data-id="element-267" data-mp="19b7tpy5q4a6o">
            <EyeIcon className="h-5 w-5 text-gold-600" aria-hidden="true" data-id="element-268" data-mp="vbyhf9kn207z" />
            They see:
          </p>
          <ul className="mt-3 divide-y divide-steel-200" data-id="element-269" data-mp="109qgqonm4om7">
            {customerSees.map(item => <li key={item} className="py-2.5 text-[15px] font-medium text-ink-800 sm:text-base" data-id="element-270" data-mp="1o15pp09wa46f">
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-6 space-y-3 text-[15px] leading-relaxed text-ink-700 sm:text-lg" data-id="element-271" data-mp="1j82vcpxamqp6">
          <p data-id="element-272" data-mp="26xx2qryufn21">And those details can determine whether a customer:</p>
          <p className="font-display text-xl font-bold uppercase text-ink-900 sm:text-2xl" data-id="element-273" data-mp="26wlyys5eefax">
            trusts you · accepts your price · leaves a review · recommends you
          </p>
          <p data-id="element-274" data-mp="2lk3zdebxgnrj">The problem isn’t that you don’t know how to repair appliances.</p>
          <p className="font-semibold text-ink-900" data-id="element-275" data-mp="2gmkmoiuvoj1p">
            The problem is that you may still be running your business without a
            professional system.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-276" data-mp="26mbk8naam1dv">
          <CTAButton label="Build my professional system" sub="Only $27 USD · Instant access" size="md" data-id="element-277" data-mp="26ppmzwmvcclu" />
        </div>
      </div>
    </section>;
}